"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = require("./logger");
exports.Log = logger_1.Log;
exports.LogLevel = logger_1.LogLevel;
exports.setLogLevel = logger_1.setLogLevel;
var config_1 = require("./config");
exports.configureAthleteAPIClient = config_1.configureAthleteAPIClient;
var getARP_1 = require("./requests/getARP");
exports.getARP = getARP_1.getARP;
var arpHook_1 = require("./hooks/arpHook");
exports.arpHook = arpHook_1.arpHook;
/**
 * 1. Fix integration tests, publish
 * 2. Write a custom hook
 */
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlete-api-client/dist/index.js
 ** module id = 362
 ** module chunks = 0
 **/